/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Telegram_Mock_PayableInputs */

const tr_landing_telegram_mock_payable = /** @type {(inputs: Landing_Telegram_Mock_PayableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ödenecek`)
};

const en_landing_telegram_mock_payable = /** @type {(inputs: Landing_Telegram_Mock_PayableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payable`)
};

const de_landing_telegram_mock_payable = /** @type {(inputs: Landing_Telegram_Mock_PayableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu zahlen`)
};

const ru_landing_telegram_mock_payable = /** @type {(inputs: Landing_Telegram_Mock_PayableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`К оплате`)
};

/**
* | output |
* | --- |
* | "Payable" |
*
* @param {Landing_Telegram_Mock_PayableInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_telegram_mock_payable = /** @type {((inputs?: Landing_Telegram_Mock_PayableInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Telegram_Mock_PayableInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_telegram_mock_payable(inputs)
	if (locale === "de") return de_landing_telegram_mock_payable(inputs)
	if (locale === "ru") return ru_landing_telegram_mock_payable(inputs)
	return tr_landing_telegram_mock_payable(inputs)
});